import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, SlicePipe } from '@angular/common';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { BaseRules, TextValues } from './texas.model';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-texas',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    TruncateModule,
    TooltipModule
  ],
  templateUrl: './texas.component.html',
  styleUrl: './texas.component.scss',
})
export class TexasComponent extends UimuiBaseStateComponent<BaseRules, TextValues> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('texas', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('texas', null);
    }
  }
  onSelect(selectionId: string, formControlName: string): void {
    if (this.baseRules['selectionId'] === "StateMinimum_VaryBetweenStates_BodilyInjuryWithMandatoryPropertyDamage") {
      this.reactiveForm.get('levelOne_Radio').setValue("umuimcoverage_levelone_radio");
    }
  }
}
